<form [formGroup]="formGroup" [class.sms-document-uploader-disabled]="disabled">
  @if (options.length > 1) {
    <glxy-form-field [required]="true">
      <glxy-label>{{ fieldTitle | translate }}</glxy-label>
      <select matNativeControl formControlName="documentType">
        @for (option of options; track option) {
          <option value="{{ option.value }}">{{ option.label | translate }}</option>
        }
      </select>
      <glxy-hint>{{ fieldHint | translate }}</glxy-hint>
    </glxy-form-field>
    <ng-container [ngTemplateOutlet]="uploader"></ng-container>
  } @else {
    <glxy-form-field [required]="true">
      <glxy-label>{{ fieldTitle | translate }}</glxy-label>
      <glxy-label-hint>{{ fieldHint | translate }}</glxy-label-hint>
      <ng-container [ngTemplateOutlet]="uploader"></ng-container>
    </glxy-form-field>
  }


  <ng-template #uploader>
    <glxy-uploader
      #documentUploader
      [hintText]="
        'SMS_REGULATION.COMMON.FILE_UPLOADER.ACCEPTED_FILE_TYPES' | translate: { numberOfMegabytes: NUMBER_OF_MEGABYES }
      "
      [maxFiles]="1"
      [maxFileSize]="fileSizeLimit"
      [accept]="acceptableFileTypes"
      [hasError]="
        formGroup.controls.documentID.invalid &&
        (formGroup.controls.documentID.dirty || !formGroup.controls.documentID.untouched)
      "
    ></glxy-uploader>
    <glxy-uploader-list
      [files]="(documentUploader.filesChanged | async) || []"
      (fileDeleted)="documentUploader.deleteFile($event)"
    ></glxy-uploader-list>
  </ng-template>
</form>
